import { render } from "./RpcTable.vue?vue&type=template&id=3b70100c&scoped=true"
import script from "./RpcTable.vue?vue&type=script&lang=js"
export * from "./RpcTable.vue?vue&type=script&lang=js"

import "@/assets/table.css?vue&type=style&index=0&id=3b70100c&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b70100c"]])

export default __exports__